function getTargetOrigin() {
  const localhostRegex = /localhost/

  let targetOrigin

  if (localhostRegex.test(window.location.origin)) {
    targetOrigin = 'http://localhost:3000'
  } else {
    targetOrigin = window.graphqlEndpoint.replace(/api/, 'main')
  }

  return targetOrigin
}

export function navigateToAphrodite(path: string) {
  window.parent.postMessage(
    JSON.stringify({
      navigateTo: path,
    }),
    getTargetOrigin()
  )
}

export function fetchMeta() {
  window.parent.postMessage('fetchMeta', getTargetOrigin())
}

export function fetchBookings() {
  window.parent.postMessage('fetchBookings', getTargetOrigin())
}

export function reloadAphrodite() {
  window.parent.postMessage('reload', getTargetOrigin())
}

export function logOutAphrodite() {
  window.parent.postMessage('logout', getTargetOrigin())
}
